import { TOGGLE_MOBILE_NAV, SET_TOGGLE_MOBILE_NAV } from "../../mutation-types";

/**
 *
 * @param {function} commit - The vuex commit function
 * @param {Boolean} payload
 * @return {Boolean} Toggle Boolean
 */
export async function toggleMobileNavHandler({commit}) {
  commit(TOGGLE_MOBILE_NAV)
}


/**
 *
 * @param {function} commit - The vuex commit function
 * @param {Boolean} payload
 * @return {Boolean} Set Toggle Boolean
 */
export async function setToggleMobileNav({commit}, payload) {
  commit(SET_TOGGLE_MOBILE_NAV, payload)
}
